import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ImageCropPageRoutingModule } from './image-crop-routing.module';

import { ImageCropPage } from './image-crop.page';
import { ImageCropperModule } from 'ngx-image-cropper';
import { CroppedImgComponent } from './cropped-img/cropped-img.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ImageCropPageRoutingModule,
    ImageCropperModule
  ],
  declarations: [
    ImageCropPage,
    CroppedImgComponent
  ],
  exports: [
    CroppedImgComponent
  ]
})
export class ImageCropPageModule {}
